import BaseApiAction from '@Actions/base-api-action';

export default class RequestReplay extends BaseApiAction {
    runAction() {
        super.invokeCloudFunction({
            name: 'replays-requestReplay',
            payload: {
                ...(this._payload || {})
            },
        });
    }
}
